import React from 'react';
import { Dropdown, Table, Icon, Image, Checkbox, Button, Radio } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import setColor from './../../common/SetColor'

import EllipsisTooltip from '../../common/EllipsisTooltip';
import defaultLogoImage from '../../../images/logo/logo-128.png'
import defaultAvaterImage from '../../../images/common/user-avatar.png'
import defaultBrokenImage from '../../../images/common/broken-image.png'
import convertCamelCase from '../../../helpers/convert-camel-case'
import convertIcon from '../../../helpers/convert-Icon';

var moment = require('moment');
const actionStyle = {
    width: "20px"
}

//let selectedRow = ''

// It validate the value is in date format
function checkValidDate(date) {
    if (!(new Date(date) === "Invalid Date") && !isNaN(new Date(date))) {
        if (date == new Date(date).toISOString()) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

// If logo is not valid so we ccan display default image
function addDefaultLogoSrc(ev) {
    ev.target.src = defaultLogoImage
}

// If image is broken so image will display
function addDefaultBrokenSrc(ev) {
    ev.target.src = defaultBrokenImage
}

// If Profile Picture is not valid so we ccan display default image
function addDefaultAvaterSrc(ev) {
    ev.target.src = defaultAvaterImage
}

// By clicking on row the resource pane will 
//open and the row is highlighted
// function selectRowClick(id) {
//     selectedRow = id
// }

// Update Some Values in the record as we want.
function updateName(value) {
    switch (value) {
        case 'user':
            return "User"
        case 'workspaceOwner':
            return "Workspace Owner"
        case 'platformAdmin':
            return "Platform Admin"
        case 'contributor':
            return "Contributor"
        case 'reviewer':
            return "Reviewer"
        case 'Private':
            return "Workspace"
        case 'Public':
            return "Public"
        default:
            return value
    }
}

// Update Some Values in the record as we want.
function setImage(imgType, src, data) {


    if (imgType === 'profilePic') {
        if (src) {
            return <Image key={src} avatar className="w_24 h_24 scaleDown" src={src} />
        } else {
            return data && data.firstName && data.lastName && <span
                key={data.firstName}
                className={`tableAvaterInitialAvatar avatar`}
                style={{ background: setColor(data.firstName.charAt(0).toUpperCase()) }} >
                {data.firstName.charAt(0).toUpperCase()}
                {data.lastName.charAt(0).toUpperCase()}
            </span>
        }
    } else if (imgType === 'logo' || imgType === 'picture') {
        if (src) {
            return <Image key={src} className="accountlogo scaleDown" src={src} onError={addDefaultBrokenSrc} />
        } else {
            return <Image key={src} className="accountlogo scaleDown" src={defaultLogoImage} />
        }
    } else {
        return <Image key={src} avatar className="w_24 h_24 scaleDown" src={defaultAvaterImage} />
    }
}


export const TableRow = props => (
    < Table.Row className="table-row" key={props.i} style={props.data && (props.data.deletionInProgress || (Object.prototype.hasOwnProperty.call(props.data, 'active') && props.data.active === false)) ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
        {

            props.tableHeader && props.tableHeader
                .filter((ti, value) => { return ti.listed })
                .map((tableItem, index) => {
                    let clickToView = {
                        text: "View",
                        isComponent: tableItem.component ? true : false
                    }
                    return <React.Fragment key={index}>
                        <Table.Cell
                            key={index}
                            style={`${tableItem.key === "action" ? actionStyle : null}`, { whiteSpace: "inherit" }}
                            collapsing={tableItem.key === "action" || index === 0 ? true : false}
                            textAlign={tableItem.key === "action" ? 'right' : null}
                            onClick={(e) => { tableItem.key ? props.selectedRowHighlight(e, props.data._id) : null, tableItem.key && props.handleDropDownItem ? props.handleDropDownItem(e, clickToView, props.data, 'single') : null }}
                            onDoubleClick={(e) => { tableItem.key ? props.selectedRowHighlight(e, props.data._id) : null, tableItem.key && props.handleDropDownItem ? props.handleDropDownItem(e, clickToView, props.data, 'double') : null }}
                            className={`
                            ${props.rowHighlight && props.rowHighlight === props.data._id ? "bg-table-selected" : null} 
                            ${props.selection ? "cursor-pointer pad_10" : null}
                            ${tableItem.replaceImage ? "text-center" : null}
                            `}
                        >



                            {tableItem.component && tableItem.component.componentType === "checkbox" &&
                                tableItem.component.actionType === "onChange" ?
                                Object.entries(props.data).map((key2, value2) => {
                                    if (tableItem.component.key === key2[0] &&
                                        tableItem.component.isDisabled === key2['isDisabled']) {
                                        return <Checkbox
                                        name="checkbox"
                                            key={value2}
                                            onChange={(e, item) => props.handleTableComponent(e, item, props.data)}
                                            toggle={tableItem.component.viewType === "toggle" ? true : false}
                                            checked={key2[1]}
                                            //defaultChecked={key2[1]}
                                            disabled={props.data.isDisabled || props.isAccountDeactivated || props.data.default}
                                            label={tableItem.component.label}
                                            slider={tableItem.component.viewType === "slider" ? true : false} />
                                    }
                                }) : null}

                            {tableItem.component && tableItem.component.componentType === "checkbox2" &&
                                tableItem.component.actionType === "onChange2" ?
                                Object.entries(props.data).map((key2, value2) => {
                                    if (tableItem.component.key === key2[0] &&
                                        tableItem.component.isDisabled === key2['isDisabled']) {
                                        return <Checkbox
                                        name="checkbox2"
                                            key={value2}
                                            onChange={(e, item) => props.handleTableComponent(e, item, props.data)}
                                            toggle={tableItem.component.viewType === "toggle" ? true : false}
                                            checked={key2[1]}
                                            //defaultChecked={key2[1]}
                                            disabled={props.data.isDisabled || props.isAccountDeactivated || props.data.isActiveDisabled}
                                            label={tableItem.component.label}
                                            slider={tableItem.component.viewType === "slider" ? true : false} />
                                    }
                                }) : null}

                            {tableItem.component && tableItem.component.componentType === "checkbox3" &&
                                tableItem.component.actionType === "onChange3" ?
                                Object.entries(props.data).map((key2, value2) => {
                                    if (tableItem.component.key === key2[0] &&
                                        tableItem.component.isDisabled === key2['isDisabled']) {
                                        return <Checkbox
                                        name="checkbox3"
                                            key={value2}
                                            onChange={(e, item) => props.handleTableComponent(e, item, props.data)}
                                            toggle={tableItem.component.viewType === "toggle" ? true : false}
                                            checked={key2[1]}
                                            //defaultChecked={key2[1]}
                                            disabled={props.data.isDisabled || props.isAccountDeactivated || props.data.isActiveDisabled}
                                            label={tableItem.component.label}
                                            slider={tableItem.component.viewType === "slider" ? true : false} />
                                    }
                                }) : null}

                            {tableItem.component && tableItem.component.componentType === "radio" &&
                                tableItem.component.actionType === "onChange" ?
                                Object.entries(props.data).map((key2, value2) => {
                                    if (tableItem.component.key === key2[0]) {
                                        return tableItem.component.option.map((opt, i) => {
                                            return <Radio
                                                key={i}
                                                label={opt.label}
                                                style={{ margin: "0 10px 0 0" }}
                                                name={props.data.email}
                                                value={opt.value}
                                                disabled={props.data.isRadioDisabled}
                                                checked={props.data.updatedValue === opt.value}
                                                onChange={(e, item) => props.handleTableComponent(e, item, props.data)}
                                            />
                                        })
                                    }
                                }) : null}

                            {
                                tableItem.multiKey && tableItem.multiKey.length !== 0 ?
                                    <EllipsisTooltip name={
                                        tableItem.multiKey.map((item, i) => {
                                            let tempText = ""
                                            Object.entries(props.data).map((key2, value2) => {
                                                if (item.name == key2[0] && item.key !== "action") {
                                                    tempText = key2[1]
                                                }
                                            })
                                            if (item.name === "profilePic" || item.name === "logo" || item.name === "picture") {
                                                return setImage(item.name, tempText, props.data)
                                            } else {
                                                return <span key={i}>{tempText} &nbsp;</span>
                                            }
                                        })}
                                        line={1}
                                        style={{ lineHeight: "16px" }} />


                                    :
                                    tableItem.type && tableItem.type === "array" ?
                                        Object.entries(props.data).map((key3, value3) => {


                                            if (tableItem.key === key3[0]) {



                                                return key3[1].map((item, ind5) => {



                                                    let display = item;


                                                    if (tableItem.displayType === "label") {
                                                        return <span key={ind5}>{ind5 + 1}. {display.id.label}<br /></span>
                                                    }
                                                    else if (tableItem.displayType === "image") {
                                                        return <Image
                                                            key={ind5}
                                                            src={display.id && display.id.image}
                                                            // className="scaleDown integrations-icons"
                                                            className={`${display.isActive ? 'display-inline-block' : 'display-none'} scaleDown integrations-icons`}
                                                        />
                                                    } else { return "NA" }
                                                })
                                            }
                                        })

                                        :
                                        Object.entries(props.data).map((key2, value2) => {
                                            let tableKey = tableItem.updatedKey ? tableItem.updatedKey : tableItem.key
                                            if (tableKey == key2[0] && tableItem.key !== "action") {
                                                if (checkValidDate(key2[1])) {
                                                    return <EllipsisTooltip
                                                        key={moment(key2[1]).format('lll')}
                                                        name={moment(key2[1]).format('lll')}
                                                        line={2} />
                                                } else if (tableItem.key === "profilePic") {
                                                    return <Image key={key2[1]} avatar className="w_24 h_24 scaleDown" src={key2[1] === undefined || key2[1] === "undefined" ? defaultLogoImage : key2[1]} onError={addDefaultAvaterSrc} />
                                                } else if (tableItem.key === "logo") {
                                                    return <Image key={key2[1]} className="scaleDown accountlogo" src={key2[1] === undefined || key2[1] === "undefined" ? defaultAvaterImage : key2[1]} onError={addDefaultLogoSrc} />
                                                }
                                                else if (typeof (key2[1]) === "boolean") {
                                                    if (key2[1] === tableItem.keyValue[0].value) {
                                                        return tableItem.keyValue[0].text
                                                    } else {
                                                        return tableItem.keyValue[1].text
                                                    }
                                                } else if (tableItem.convertCamelCase) {
                                                    return convertCamelCase(key2[1])
                                                } else if (tableItem.replaceImage) {
                                                    return <Icon key={key2[1]} name={convertIcon(key2[1])} />
                                                } else if (tableItem.key === "email") {
                                                    return <EllipsisTooltip
                                                        key={key2[1]}
                                                        name={updateName(key2[1] ? key2[1].toString():"")}
                                                        line={1} />
                                                } else {
                                                    return <EllipsisTooltip
                                                        key={key2[1]}
                                                        name={updateName(key2[1] ? key2[1].toString():"")}
                                                        line={2} />
                                                }
                                            }
                                        })
                            }

                            {
                                tableItem.key === "action" ?
                                    tableItem.actionType && tableItem.actionType === props.actionType ?
                                        <Button.Group>
                                            {tableItem.actions.map((item, i) => {
                                                if (!item.key) {
                                                    return item.disabled ? null : <Button
                                                        key={i}
                                                        icon
                                                        onClick={(e, item) => props.handleDropDownItem(e, item, props.data)}
                                                        text={item.name}>
                                                        <Icon
                                                            className={item.className ? item.className : null}
                                                            name={item.icon ? item.icon : "file"}
                                                        />
                                                    </Button>
                                                } else { return false }
                                            })
                                            }
                                            {tableItem.actions.map((item, i) => {
                                                if (item.key) {
                                                    return Object.entries(props.data).map((key3, value3) => {
                                                        if (item.key == key3[0]) {

                                                            return key3[1] ? null : <Button
                                                                key={value3}
                                                                icon
                                                                onClick={key3[1] ? null : (e, item) => props.handleDropDownItem(e, item, props.data)}
                                                                text={item.name}>
                                                                <Icon
                                                                    className={item.className ? item.className : null}
                                                                    name={item.icon ? item.icon : "file"}
                                                                    disabled={item.disabled}
                                                                />
                                                            </Button>
                                                        }
                                                    })
                                                } else {
                                                    return false
                                                }
                                            })}
                                        </Button.Group>
                                        :
                                        <Dropdown key={`1_${index}`} icon='ellipsis vertical' pointing="right">
                                            <Dropdown.Menu key={`2_${index}`}>
                                                {tableItem && tableItem.actions && tableItem.actions.map((item, i) => {
                                                    if (!item.key) {
                                                        return <React.Fragment key={`3_${i}`}>
                                                            <Dropdown.Item
                                                                key={`4_${i}`}
                                                                icon={item.icon ? <Icon className={item.className} name={item.icon} /> : null}
                                                                text={item.name}
                                                                disabled={item.disabled}
                                                                onClick={(e, item) => props.handleDropDownItem(e, item, props.data)}
                                                            />
                                                            <Dropdown.Divider />
                                                        </React.Fragment>
                                                    } else { return false }
                                                })
                                                }
                                                {tableItem && tableItem.actions && tableItem.actions.map((item, i) => {
                                                    if (item.key) {
                                                        return Object.entries(props.data).map((key3, value3) => {
                                                            const userCheck = props.data.users
                                                            ? props.data.role === "workspaceOwner" || !key3[1]
                                                            : true;
                                                            if (item.key === key3[0] && userCheck) {
                                                                return <React.Fragment key={`5_${i}`}>
                                                                    <Dropdown.Item
                                                                        icon={item.icon ? <Icon className={item.className} name={item.icon} /> : null}
                                                                        key={`6_${i}`}
                                                                        text={item.name}
                                                                        disabled={key3[1]}
                                                                        onClick={key3[1] ? null : (e, item) => props.handleDropDownItem(e, item, props.data)}
                                                                    />
                                                                    <Dropdown.Divider />
                                                                </React.Fragment>
                                                            }
                                                        })
                                                    } else {
                                                        return false
                                                    }
                                                })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown> : null
                            }
                        </Table.Cell>

                        {
                            props.tableHeader.length - 1 === index ? null :
                                <Table.Cell className="pad_0" />
                        }
                    </React.Fragment>
                })
        }
    </Table.Row >
);

TableRow.propTypes = {
    data: PropTypes.object.isRequired,
    selection: PropTypes.bool.isRequired,
    actionType: PropTypes.string.isRequired,
    selectedRowHighlight: PropTypes.func,
    rowHighlight: PropTypes.string
};